// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qPJe","comment":"styles_comment__2z92T"};